<!--
 * @author: JJ
 * @since: 2024-10-08
 * Corporate .vue
-->
<template>
    <div class="container pbrem2">
        <Header />
        <div class="top_nav ptb10">
            <div class="w1400 flex-box">
                <img src="../../assets/static/images/jj_logo_new.png" @click="toIndex" class="logo" alt="">
                <div class="flex-grow-1 pl60">
                    <div class="pl60 top_title fs18">收银台</div>
                </div>
            </div>
        </div>
        <div class="w1400 mt25 fs14 cursor"><span class="col90">当前位置：</span><router-link to="/" class="col04">首页
                /</router-link>
            <!-- <router-link to="/Cart" class="col04">采购车 /</router-link> -->
            <span class="col04"> 结算 /</span><span class="now_page"> 收银台</span>
        </div>
        <div class="mt15 col90 fs14 w1400">正在使用公对公付款，交易将在<span class="zprice1">{{ auto_close }}</span>分钟后取消，请及时付款并上传付款凭证！</div>
        <div class="w1400 mt15">
            <div class="flex-box">
                <div class="left_box">
                    <div class="flex-box">
                        <img src="../../assets/static/icon/jj_icard.png" class="ico" alt="">
                        <div class="pl15 col04 fs16 fwb">公对公付款</div>
                    </div>
                    <div class="mt84 tc">
                        <div class="fs14 col04">付款金额（元）</div>
                        <div class="mt15 fwb coleb fs22">¥{{ order.pay_fee }}</div>
                    </div>
                    <!-- <div class="flex-box mt36 flex-center">
                        <div class="fs16 col96 mr10">支付剩余时间</div>
                        <countDown :totalTime="endTime"></countDown>
                    </div> -->
                </div>
                <!-- <div class="right_box flex flex-col flex-center plr108">
                    <img src="../../assets/static/icon/jj_user.png" class="user" alt="">
                    <div class="colf fs16 mt70">账号主体<span class="pl40 colf fs16 fw600">上海某某机构</span></div>
                    <div class="colf fs16 mt20">账号名称<span class="pl40 colf fs16 fw600">婕尔GISELLELIGNE</span></div>
                </div> -->
                <div class="right_box" v-if="order.corporate_account.length > 0">
                    <div class="col04 fs16 fwb">付款信息</div>
                    <div class="info fs14 col04 mt60">
                        <div v-for="(item, index) in order.corporate_account" :key="index">{{ item.title }}： 
                            {{ item.value }}</div>

                    </div>
                </div>
            </div>
        </div>
        <div class="mt15 w1400 plr30 ptb20 bgf">
            <div class="flex-box">
                <img src="../../assets/static/icon/jj_tips.png" class="ico20" alt="">
                <div class="col127 fs16 fwb pl15">付款须知</div>
            </div>
            <div class="fs14 col90 mt60">
                <div v-html="article.content"></div>
            </div>
        </div>
        <div class="mt15 w1400 plr30 ptb20 bgf pb100">
            <div class="fwb col04 fs16">付款凭证</div>
            <div class="tips_nav">
                <!-- 隐藏里面的内容 -->
                <!-- <div class="flex-box flex-center">
                    <img src="../../assets/static/icon/jj_icon_warning.png" class="ico22" alt="">
                    <div class="coleb pl10 fs16">待平台审核</div>
                </div> -->
            </div>
            <div class="upload_nav">
                <upLoad @upSuc="onUpload">
                    <img v-if="certificate" :src="certificate" class="upload_img">
                    <img v-else src="../../assets/static/images/jj_upload_null.png" class="upload_img" alt="">
                    <div class="moudle flex-box flex-center"
                        v-if="order.pay_certificate && order.pay_certificate.status == 'checked'">
                        <img src="../../assets/static/icon/jj_tips1.png" class="tips" alt="">
                    </div>
                </upLoad>

            </div>
            <el-button class="btn_submit cursor" :loading="createStatus" :disabled="createStatus"
                :class="certificate && (!order.pay_certificate || order.pay_certificate.status === 'failed') ? '' : 'disabled'"
                @click="certificate && (!order.pay_certificate || order.pay_certificate.status === 'failed') ? onSave() : ''">提交审核</el-button>
        </div>
        <popup :visible="show" ref="pop" :confirmText="false" :cancleText="false" @close="close">
            <div class="popup">
                <img src="../../assets/static/icon/jj_popup_close.png" class="close" @click="close" alt="">
                <img src="../../assets/static/icon/jj_popup_success.png" class="success" alt="">
                <div class="col04 fs16 fwb lh30 mt25 tc">提交成功</div>
                <div class="mt15 col90 fs14 tc">您的付款凭证已提交，请等待后台审核。</div>
            </div>
        </popup>
    </div>
</template>

<script setup>
import countDown from "../../components/countDown1.vue";
import popup from "../../components/popup.vue";
import upLoad from "@/components/Upload.vue";
import { ref, onMounted } from "vue"
import { useHead } from '@unhead/vue'
onMounted(() => {
    useHead({
        title: "收银台-小狮优选",
        meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    })
})
let pop = ref(null)

</script>
<script>
export default {
    data() {
        return {
            article: { content: '' },
            orderinfo: {},
            order: { corporate_account: [], pay_fee: 0, pay_certificate: null },
            timeData: {},
            duigongPopStatus: false,
            createStatus: false,
            certificate: '',
            show: false,
            auto_close: 0,
        }
    },
    created() {
        this.orderinfo = JSON.parse(decodeURIComponent(this.$route.query.data));

    },
    mounted() {
        if (this.$cookies.get("token")) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
        this.auto_close = this.$root.$data.config.app.auto_close; //关闭时间
        this.getOrderDetail();

        let id = this.$root.$data.config.app.duigong_agreement || 0;
        this.$api.getAgreement({ id: id }).then(ret => {
            this.article = ret.data;
        })
    },
    methods: {
        toIndex() {
            this.$router.push('/')
        },
        //支付结果
        getOrderDetail() {
            this.$api.PayDuigongOrder({ id: this.orderinfo.orderSN, showToast: true }).then(ret => {
                this.order = ret.data;
            }).catch(ret => {
                that.$message({
                    customClass: 'custom-message',
                    message: ret.msg,
                    type: "error",
                    duration: 3000,
                });
            })
        },
        onUpload(e) {
            this.certificate = e;
        },
        close() {
            this.show = false;
            this.$router.replace('/Order')
        },
        onSave() {
            let page = this;
            page.createStatus = true;
            this.$confirm("确定提交审核？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                page.$api.PayDuigongOrderSubmit({ id: page.orderinfo.orderSN, certificate: page.certificate, showToast: true }).then(ret => {
                    page.createStatus = false;
                    page.show = true;
                }).catch(err => {
                    page.createStatus = false;
                })
            })

        },
    }

}
</script>
<style lang="less" scoped>
.top_nav {
    width: 100%;
    background: #f9f9f9;

    .logo {
        width: 170px;
        height: auto;
    }

    .pl60 {
        padding-left: 60px;
    }

    .top_title {
        padding-left: 60px;
        font-weight: 500;
        color: #040404;
        height: 100px;
        line-height: 100px;
        position: relative;

        &::before {
            content: '';
            width: 2px;
            height: 101px;
            background: rgba(98, 134, 171, 0.4);
            display: inline-block;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

.col127 {
    color: #1275FF;
}

.cu {
    cursor: pointer;
}

.mt40 {
    margin-top: 40px;
}

.mt45 {
    margin-top: 45px;
}

.mt25 {
    margin-top: 25px;
}

.left_box {
    width: 775px;
    height: 450px;
    background: #FFFFFF;
    padding: 20px 30px;

    .ico {
        width: 39px;
        height: auto;
    }
}

.right_box {
    width: 605px;
    height: 450px;
    margin-left: 20px;
    // background-image: url('../../assets/static/images/jj_co_bg.png');
    background: #fff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 20px 30px;
}

.mt84 {
    margin-top: 84px;
}

.coleb {
    color: #EB3F25;
}

.col96 {
    color: #969696;
}

.mt36 {
    margin-top: 36px;
}

.user {
    width: 126px;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.plr108 {
    padding-left: 108px;
    padding-right: 108px;
}

.mt70 {
    margin-top: 60px;
}

.ptb35 {
    padding-top: 35px;
    padding-bottom: 54px;
}

.plr44 {
    padding-left: 44px;
    padding-right: 44px;
}

.info {
    width: 100%;
    background: #FBFCFD;
    padding: 33px 80px 33px;
}

.mt60 {
    margin-top: 60px;
}

.ico20 {
    width: 20px;
    height: auto;
}

.pr65 {
    padding-right: 65px;
}

.upload_nav {
    width: 660px;
    height: 387px;
    border-radius: 8px;
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .upload_img {
        width: 660px;
        height: 387px;
        border-radius: 8px;
        position: relative;
        z-index: 1;
        object-fit: cover;
    }

    .moudle {
        width: 660px;
        height: 387px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        border-radius: 8px;
        background: rgba(86, 86, 86, 0.4);
    }

    .moudle .tips {
        width: 208px;
        height: auto;
    }
}

.tips_nav {
    height: 33px;
    margin-top: 6px;
    margin-bottom: 19px;
}

.ico22 {
    width: 22px;
    height: auto;
}

.btn_submit {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    width: 660px;
    height: 60px;
    line-height: 60px !important;
    text-align: center;
    margin-top: 55px;
    margin-left: auto !important;
    margin-right: auto !important;
    display: block;
    padding: 0;

    background: #1275FF;
    border-radius: 8px;

    &.disabled {
        background: #BDD3FF;
    }
}

.mb564 {
    margin-bottom: 50px;
}

.pb100 {
    padding-bottom: 100px !important;
}

.popup {
    width: 422px;
    height: 343px;
    background-image: url('../../assets/static/images/jj_popup_bg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    padding-top: 109px;

    .close {
        width: 20px;
        height: auto;
        position: absolute;
        top: 57px;
        right: 32px;
    }

    .success {
        width: 66px;
        height: auto;
        display: block;
        margin-left: auto;
        margin-right: auto;

    }
}
</style>
